export enum PublicShippingPriceType {
  Predicted = 'PREDICTED',
  Final = 'FINAL',
}
